export const TAXID_FLAG = "ssn";
export const ADDRESS_TYPE_PRIMARY = "primary";
export const PERSONAL = "personal";
export const PHONETYPE_MOBILE = "mobile";

export const SSN_APPLICANT_ERROR_KEY = "ssnNotUnique";
export const EMAIL_APPLICANT_ERROR_KEY = "emailNotUnique";
export const PHONE_APPLICANT_ERROR_KEY = "phoneNotUnique";
export const EMAIL_SSN_APPLICANT_ERROR_KEY = "emailAddress";

export const OKTA_TOKEN_STORAGE_KEY = "okta-token-storage"
export const OKTA_ACCESS_TOKEN_KEY = "accessToken";
export const OKTA_EXPIRED_EVENT = "expired";

export const BRANCH_LIST_KEY = "branch-list";

export const APPLIED_FILTERS_KEY = "appliedFilters";
export const LOAD_SEARCH_TEXT = "loadSearchText";
export const APPLIED_DATE_KEY = "appliedDate";
export const APPLIED_SEARCH_TEXT = "appliedSearchText";
export const PRODUCT_MINOR_SAVINGS = "Minor Savings";

export const PRIMARY_APPLICANT_PERSONAL_EMAIL_ADDRESS_LABEL = "Primary Applicant Personal Email Address";
export const SECONDARY_APPLICANT_PERSONAL_EMAIL_ADDRESS_LABEL = "Co-Applicant Personal Email Address";

export const PRIMARY_APPLICANT_LABEL = "Primary Applicant";
export const SECONDARY_APPLICANT_LABEL = "Co-Applicant";
export const MINOR_APPLICANT_LABEL = "Minor Applicant";
export const ADULT_APPLICANT_LABEL = "Adult Applicant";
export const DEFAULT_OLB_ENROLLMENT_GROUP_ID = 26;

export const PRODUCT_PERMISSION_DENIED_MESSAGE = "User is not authorized to view this application.";
export const NULL_APPLICANTS_ERROR_MESSAGE = "No applicants have been provided for this application.";

export const TIMELINE_ICON_COMPLETE_COLOR = "#1a894a";
export const TIMELINE_ICON_ERROR_COLOR = "#d43131";
export const TIMELINE_ICON_DEFAULT_COLOR = "#949191";
export const TIMELINE_ICON_PROGRESS_COLOR = "#000033";
export const TIMELINE_ICON_PARTIAL_COLOR = "#F4E239";

export const TIMELINE_SUCCESS_MAT_ICON = "check_circle";
export const TIMELINE_FAILURE_MAT_ICON = "cancel";
export const TIMELINE_DEFAULT_MAT_ICON = "radio_button_unchecked";
export const TIMELINE_REVIEW_MAT_ICON = "visibility";
export const TIMELINE_NOT_APPLICABLE_MAT_ICON = "remove_circle";
export const TIMELINE_PARTIAL_SUCCESS_MAT_ICON = "error";

export const TIMELINE_SUCCESS = "Success";
export const TIMELINE_FAIL = "Fail";
export const PARTIAL_ENROLLMENT = "Partial";

export const FSR_RM_ASSISTED = 3;

export const APPLICATION_TYPE_NEW_CLIENT_APPLICATION = 1;
export const APPLICATION_TYPE_JOINT_ACCOUNT_MAINTENANCE = 2;

export const ADDRESS_VALIDATION_MESSAGE = "Please enter a valid house number and street address";
export const PRIMARY_APPLICANT_ADDRESS_LINE_1 = "Primary Applicant Address Line 1";
export const CO_APPLICANT_ADDRESS_LINE_1 = "Co-Applicant Address Line 1";

export const REPORT_EXPORT_ERROR_MESSAGE = "Unable to generate report. Please try again later."

export const SELECTED_PRODUCT_CODE = "selectedProductCode";
export const EMPLOYEE_PRODUCT_EMAIL_FOR_VALIDATION = ["texascapital.com", "texascapitalbank.com"];
export const EMAIL_VALIDATION_MESSAGE = "Please use a valid personal email address";
export const PRIMARY_APPLICANT_EMAIL = "Primary Applicant Personal Email Address";
export const CO_APPLICANT_EMAIL = "Co-Applicant Personal Email Address";

export const SOCURE_SDK_SETTING_KEY = "socureSubAccountSdkKey";
export const SOCURE_IDPLUS_SETTING_KEY = "socureSubAccountIdPlusKey";
export const ALLOY_DOCV_WORKFLOW_VERSION_KEY = "alloyDocVWorkflowVersion";

export const SOCURE_VERIFY_LINK_KEY = "socure-verify-link";

export const APPLICANT_NAME_ALLOW_SPECIAL_CHARACTER = "allows the special characters - . '";

export const APPLICANT_ADDRESS_LINE_ALLOW_SPECIAL_CHARACTER = `allows the special characters @&*()\- ; ' : " , . `;

export const BRAND_BASK_BANK = "Bask Bank";

export const SUPPRESS_ACCOUNT_DETAILS = "suppressAccountDetails";
export const SUPPRESS_ACCOUNT_DETAILS_VALUE = "true";

export const MASKED_STRING = "*********";
export const VISIBILITY_ON_LABEL = "Mask";
export const VISIBILITY_OFF_LABEL = "Unmask";
export const VISIBILITY_ICON = "visibility";
export const VISIBILITY_OFF_ICON = "visibility_off";

export const PRIMARY_APPLICANT_PHONE_NUMBER = "Primary Applicant Phone Number";
export const CO_APPLICANT_PHONE_NUMBER = "Co-Applicant Phone Number";

export const PRIMARY_APPLICANT_LAST_NAME = "Primary Applicant Last Name";
export const CO_APPLICANT_LAST_NAME = "Co-Applicant Last Name";
export const EMPLOYEE_SAVINGS_PRODUCT_UID = "58916f59-ae86-4305-b2d2-91df5998e65e";

export const APPLICATION_LOG_REQUEST_SESSION_KEY = "application-log-request";
export const ONBOARDING_REQUEST_SESSION_KEY = "onboarding-request";
export const NAO_APPLICATION_LOG_REQUEST_KEY = "nao-application-log-request";

export const NAO_PRODUCT_SELECTION_ROUTE = "/nao/productSelection";

export const NOT_AVAILABLE = "Not available";

export const ELIGIBILITY_FAILURE = "Failure"



